import { Link } from '@mui/material'
import { ChevronIcon } from '../../../../Components/Icons/Icons'
import { Link as RouterLink, useSearchParams } from 'react-router-dom'
import { LinkChip } from '../../../../Components/Material/Chips'

const enquiryPath = (): string => {
  const [searchParams] = useSearchParams()

  return `/responses?${searchParams.toString()}`
}
const ArrowBackIcon = <ChevronIcon />

const BackToEnquiryLink = (): JSX.Element => (
  <Link component={RouterLink} variant='anchor' to={enquiryPath()}>
    <LinkChip
      icon={ArrowBackIcon}
      label='Back'
      largeLabel='Back to your enquiry'
    />
  </Link>
)

export default BackToEnquiryLink
